import { useTranslation } from "react-i18next";

import { Icon, Message } from "semantic-ui-react";

import { RichTextViewer } from "simplydo/react/richtext";

import { InfoTextHeader } from "./styles";

const CustomInfoText = ({ field }) => {
  const { t } = useTranslation();
  return (
    <Message>
      <InfoTextHeader>
        <Icon name="info circle" color="#4B4B4B" size="big" />
        <h3>{t("ideas.custom.supporting.info")}</h3>
      </InfoTextHeader>
      <RichTextViewer value={field.content} />
    </Message>
  );
};

export default CustomInfoText;
